import {
  getPromos,
  Promo,
  selectPromosDataState,
  selectReferrerPromo,
} from '@bonanza-social/promos';
import { getPromo as getLandingPromo } from '@bonanza-social/auth';
import { useDispatch, useSelector } from '@bonanza-social/toolkit/state';
import { ScrollView } from '@bonanza-social/moonlight';
import MissingReferrerPromo from './MissingReferrerPromo';
import { useEffect, useMemo } from 'react';
import AvailableReferrerPromo from './AvailableReferrerPromo';
import ReffererPromoLimitReached from './ReffererPromoLimitReached';
import InviteFriendsSkeleton from './InviteFriendsSkeleton';

function InviteFriends() {
  const referrerPromo = useSelector(selectReferrerPromo);
  const referrerPromoDataState = useSelector(selectPromosDataState);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getPromos());
    dispatch(getLandingPromo());
  }, [dispatch]);

  const MainComponent = useMemo(() => {
    if (!referrerPromo) {
      return MissingReferrerPromo;
    }

    if (
      referrerPromo.playerExecutionCount === referrerPromo.playerExecutionLimit
    ) {
      return ReffererPromoLimitReached;
    }

    return AvailableReferrerPromo;
  }, [referrerPromo]);

  return (
    <ScrollView
      contentContainerStyle={{
        paddingBottom: {
          mobile: undefined,
          tablet: 'space-2000',
          desktop: 'space-2000',
        },
        width: {
          mobile: undefined,
          tablet: 650,
          desktop: 650,
        },
        marginHorizontal: {
          mobile: undefined,
          tablet: 'auto',
          desktop: 'auto',
        },
      }}
      showsVerticalScrollIndicator={false}
    >
      {referrerPromoDataState.match('idle|pending|refreshing') ? (
        <InviteFriendsSkeleton />
      ) : (
        <MainComponent referrerPromo={referrerPromo as Promo} />
      )}
    </ScrollView>
  );
}

export default InviteFriends;
